import { SignupModel, ISignup } from "@core/models";

export class SignupDTO extends SignupModel {
  prepareCreateData() {
    return {
      adresse: this[ISignup.address],
      code_postal: this[ISignup.postalCode],
      couverts: this[ISignup.seats],
      email: this[ISignup.email],
      facebook: this[ISignup.facebook],
      id_categorie: this[ISignup.categoryId],
      nom_etab: this[ISignup.etabName],
      nom: this[ISignup.lastname],
      origine_inscription: this[ISignup.originInscription],
      nb_employee: this[ISignup.employeesNumber],
      password: this[ISignup.password],
      prenom: this[ISignup.firstname],
      presentation: this[ISignup.description],
      segment: this[ISignup.segment],
      telephone: this[ISignup.phone],
      ville: this[ISignup.city],
      web: this[ISignup.web],
      opt_in: this[ISignup.optIn],
    };
  }
}
